<section class="contact-info" [appReveal]>
  <p class="contact-info__eyebrow" i18n="@@contactInfo.eyebrow">聯絡資料 Contact Info</p>

  <ul class="contact-info__list">
    <li class="contact-info__item" *ngFor="let row of infoRows">
      <span class="contact-info__icon" aria-hidden="true">
        <ng-container [ngSwitch]="row.iconKey">
          <svg *ngSwitchCase="'mail'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
          <svg *ngSwitchCase="'phone'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
          <svg *ngSwitchCase="'map'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
        </ng-container>
      </span>
      <div class="contact-info__text">
        <p class="contact-info__caption">{{ row.label }}</p>
        <a *ngIf="row.href; else plainValue" class="contact-info__value contact-info__value--link" [href]="row.href">{{ row.value }}</a>
        <ng-template #plainValue>
          <p class="contact-info__value">{{ row.value }}</p>
        </ng-template>
      </div>
    </li>
  </ul>

  <hr class="contact-info__divider">

  <p class="contact-info__heading" i18n="@@contactInfo.hours.heading">辦公時間</p>
  <p class="contact-info__hours-single" i18n="@@contactInfo.hours.value">09:00-18:00</p>

  <hr class="contact-info__divider">

  <p class="contact-info__heading" i18n="@@contactInfo.followUs">關注我們 Follow Us</p>
  <div class="contact-info__social">
    <a class="contact-info__social-link"
       *ngFor="let link of socialLinks"
       [href]="link.href"
       [attr.aria-label]="link.label"
       target="_blank"
       rel="noopener">
      <ng-container [ngSwitch]="link.iconKey">
        <svg *ngSwitchCase="'facebook'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
        <svg *ngSwitchCase="'instagram'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="5"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg>
        <svg *ngSwitchCase="'whatsapp'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>
      </ng-container>
    </a>
  </div>
</section>
